<template>
    <alert-error v-if="maintenanceMode">
        {{ $t("maintenance_mode.description") }}
    </alert-error>
</template>

<script lang="ts" setup>
const maintenanceMode = useState<boolean | null>("maintenance", (): boolean | null => null);

const baseUrl = useBaseUrl();
const route = useRoute();

/**
 * Checks for the global maintenance mode status of the API. Any failed request (503, other server errors or an
 * unreachable backend) is treated as maintenance.
 */
const refresh = async () => {
    let failed = false;

    try {
        await $fetch(`${baseUrl}status`);
    } catch {
        failed = true;
    }

    maintenanceMode.value = failed || route.hash === "#maintenance";

    if (maintenanceMode.value) {
        setTimeout(refresh, 10000);
    }
};

refresh();
</script>
